import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './contact.css';

const Contact = () => (
  <div className="gpt3__possibility section__padding" id="contact">
    <div className="gpt3__possibility-image">
    <div className="gpt3__header-content__input">
        <input type="email" placeholder="Your Email Address" />
        <input type="email" placeholder="Subject" />
        <input aria-rowcount={5} type="email" placeholder="message" />
        <button type="button">Get Started</button>
      </div>
    </div>
    <div className="gpt3__possibility-content">
      <h1 className="gradient__text">Find Us</h1>
      <p>Madam Mercy Road Gwagwalada Abuja</p>
      <h4 className="gradient__text">Opening Hours</h4>
      <p>Mon - Fri: 10:00 am - 5:00 pm</p>
      <p></p>


    </div>
  </div>
);

export default Contact;
